import { render, staticRenderFns } from "./OrderSummaryHeader.vue?vue&type=template&id=8e2aca92&scoped=true&"
import script from "./OrderSummaryHeader.vue?vue&type=script&lang=js&"
export * from "./OrderSummaryHeader.vue?vue&type=script&lang=js&"
import style0 from "./OrderSummaryHeader.vue?vue&type=style&index=0&id=8e2aca92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2aca92",
  null
  
)

export default component.exports